import React from 'react';
import {
    //   BrowserRouter as Router,
    //   Route,
    //   Switch,
    Link,
    withRouter
} from 'react-router-dom';
import constants from '../ndbk-constants'
import MainNav from '../components/MainNav.js';
import Footer from '../components/Footer';
import {
    RadioGroup, Radio, InputGroup, Button, Tooltip, Icon, Spinner
} from "@blueprintjs/core";

import {
    CardElement,
    injectStripe,
    StripeProvider,
    Elements,
} from 'react-stripe-elements';

const info = {
    donation: {
        lockedValue: false,
        value: 1000,
        extra: "",
        info: "One-time charge in the form of donation to support the development of Nodebook.",
    },
    monthly: {
        lockedValue: true,
        value: 899,
        extra: "per month",
        info: <div>Subscription fee that automatically renews every month.<br />Can be cancelled at any time.</div>,
    },
    yearly: {
        lockedValue: true,
        value: 9999,
        extra: "per year",
        info: <div>
            <div style={{ marginBottom: "10px" }}><span style={{ color: "#0D8050", fontSize: "1.25em", fontWeight: "bold", marginRight: "10px" }}>Save 10%!</span>(instead of 12 x $8.99 = $107.88)</div>
            <div>Subscription fee that automatically renews every year.<br />Can be cancelled at any time.</div>
        </div>,
    },
    lifetime: {
        lockedValue: true,
        value: 39999,
        extra: "",
        info: <div>One-time charge that includes a lifetime access to all current and future versions of Nodebook. Once activated it is permanently valid.</div>,
    }
}

class CheckoutForm extends React.Component {
    constructor(props) {
        super(props)
        const isGuest = (props.auth && props.auth.user && props.auth.user.isGuest === true)
        const isPremium = (this.props.auth && this.props.auth.user && this.props.auth.user.plan === 'premium')
        const selected = (isGuest || isPremium) ? "donation" : "yearly"
        this.state = {
            selected: selected,
            ...info[selected],
            status: null,
        }
    }

    submit = () => {
        const payment_type = this.state.selected

        this.setState({
            status: "processing"
        }, async () => {
            let { token } = await this.props.stripe.createToken({ name: "Name" });
            if (!token) {
                this.setState({
                    status: "error"
                })
                return
            }

            let response = await fetch("https://nodebook.io/api/charge", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token: token.id,
                    value: this.state.value,
                    payment_type: this.state.selected,
                })
            });

            if (response.ok) {
                this.setState({
                    status: "success"
                }, () => {
                    if (["monthly", "yearly", "lifetime"].indexOf(payment_type) !== -1) {
                        this.props.auth.adjustAuthUser({
                            plan: "premium"
                        })
                    }
                })
            } else {
                this.setState({
                    status: "error",
                })
            }
            // setTimeout(() => {
            //     if (Math.random() > 0.5) {
            //         this.setState({
            //             status: "success"
            //         })
            //     } else {
            //         this.setState({
            //             status: "error"
            //         })
            //     }
            // }, 1500);
        })

    }

    render() {

        const isGuest = (this.props.auth && this.props.auth.user && this.props.auth.user.isGuest === true)
        const isPremium = (this.props.auth && this.props.auth.user && this.props.auth.user.plan === 'premium')

        const errorMsg = (
            <div style={{ display: "flex", alignItems: "top", flex: 1, color: "#A82A2A" }}>
                <div style={{ marginRight: "10px" }}>
                    <Icon icon="error" />
                </div>
                <div>
                    There was an error processing the payment.<br />Please make sure all information is correct.
                </div>
            </div>
        )

        const successMsg = (
            <div style={{ display: "flex", alignItems: "top", flex: 1, color: "#0A6640" }}>
                <div style={{ marginRight: "10px" }}>
                    <Icon icon="tick-circle" />
                </div>
                <div>
                    Purchase complete. Thank you!
                </div>
            </div>
        )

        return (
            <div style={{ margin: "60px auto" }}>
                <div style={{ marginBottom: "10px" }}><strong>Amount:</strong></div>
                <InputGroup
                    style={{ width: "100px" }}
                    value={this.state.value * 0.01}
                    onChange={e => this.setState({ value: e.target.value.replace(/[^\d]/gi, '') * 100, status: null })}
                    leftIcon="dollar"
                />

                <div style={{
                    margin: "20px 0"
                }}>
                    <div style={{ marginBottom: "10px" }}><strong>Card information:</strong></div>
                    <div style={{ display: "grid", alignItems: "center", gridTemplateColumns: "380px max-content", columnGap: "10px", gridColumnGap: "10px" }}>
                        <div style={{ border: "1px solid #BFCCD6", borderRadius: "3px", padding: "5px", background: "white" }}>
                            <CardElement onChange={() => { this.setState({ status: null }) }} />
                        </div>
                        <Tooltip
                            content={<div>Payments are processed through Stripe.<br />No card information is stored on our servers.</div>}
                            position="right"
                        >
                            <Icon icon="info-sign" style={{ cursor: "help", color: "#BFCCD6" }} />
                        </Tooltip>
                    </div>

                    {/* <div style={{ color: "#8A9BA8", marginTop: "20px", fontSize: "0.875em" }}></div> */}
                </div>
                <div style={{ display: "flex", alignItems: "top" }}>
                    <div style={{ marginRight: "20px" }}>
                        <Button onClick={this.submit} text={this.state.selected === "donation" ? "Donate" : "Purchase"} intent="success" icon={this.state.selected === "donation" ? "bank-account" : "shopping-cart"} />
                    </div>
                    {this.state.status === "processing" && <Spinner size="24" />}
                    {this.state.status === "error" && errorMsg}
                    {this.state.status === "success" && successMsg}
                </div>

            </div>
        );
    }
}

const StripeCheckout = injectStripe(CheckoutForm);


class FeaturesPage extends React.Component {


    componentDidMount() {
        document.title = constants.WEBSITE_TITLE
        // window.scrollTo(0,0)
    }
    render() {

        return (
            <div className="landing">
                <main>
                    <MainNav {...this.props} />
                    <StripeProvider apiKey="pk_live_8M7HqpGS6TIVjmh6KJdrFy6B006tub9rY7">
                        <Elements>
                            <StripeCheckout {...this.props} />
                        </Elements>
                    </StripeProvider>
                </main>


            </div>
        );
    }
}

export default withRouter(FeaturesPage);


// WEBPACK FOOTER //
// ./src/pages/PaymentPage.js